import { Stack } from '@mui/material';
import {
  FlowHumanTaskBlockWorkContextContentType,
  type FlowHumanTaskWorkContext,
} from 'flow-schema';

import { isDefined } from 'common';

import { HumanTaskWorkContextVariants } from './Variants';
import {
  getDefaultHumanTaskWorkContextConfig,
  humanTaskWorkContextContentTypeNames,
} from './constants';
import { useReactFlowViewContext } from '../../../../../context/context';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSelectField } from '../../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../../ConfigFields/useSelectedNodeField';

interface HumanTaskWorkContextCardProps {
  fieldNamePrefix: string;
}

export function HumanTaskWorkContextCard(props: HumanTaskWorkContextCardProps) {
  const { fieldNamePrefix } = props;
  const { value: contentType } = useSelectedNodeField<
    FlowHumanTaskBlockWorkContextContentType | undefined
  >(`${fieldNamePrefix}.contentType`);
  const { setValue: setField } = useSelectedNodeField<FlowHumanTaskWorkContext>(fieldNamePrefix);
  const { selectedNodeData } = useReactFlowViewContext();
  const isFlowRun = isDefined(selectedNodeData?.run);

  return (
    <Stack gap={2}>
      <BlockSelectField
        fieldName={`${fieldNamePrefix}.contentType`}
        label="Content Type"
        options={Object.values(FlowHumanTaskBlockWorkContextContentType)
          .filter((type) => {
            if (type === FlowHumanTaskBlockWorkContextContentType.VoiceCall) {
              return (
                isFlowRun || contentType === FlowHumanTaskBlockWorkContextContentType.VoiceCall
              );
            }
            return true;
          })
          .map((type) => ({
            label: humanTaskWorkContextContentTypeNames[type],
            value: type,
          }))}
        onChange={(event) => {
          const type = event.target.value as FlowHumanTaskBlockWorkContextContentType;
          setField(getDefaultHumanTaskWorkContextConfig(type));
        }}
      />
      <Stack gap={2} aria-roledescription="Work Context Details">
        {contentType !== FlowHumanTaskBlockWorkContextContentType.Portal && (
          <BlockValueTemplateField fieldName={`${fieldNamePrefix}.name`} label="Name" />
        )}
        {isDefined(contentType) && (
          <HumanTaskWorkContextVariants variant={contentType} fieldNamePrefix={fieldNamePrefix} />
        )}
      </Stack>
    </Stack>
  );
}
